import { beforeAuthGuard } from "@/features/auth/guards";
import { SettingsLayoutContainer } from "@/features/settings-layout/containers/settings-layout-container";
import { createFileRoute } from "@tanstack/react-router";

// Layout route for all /settings/* pages
export const Route = createFileRoute("/settings")({
  beforeLoad: beforeAuthGuard,
  component: SettingsLayoutContainer,
});
